// Shared knowledge for the per-tab audit history panels.
//
// Two things live here so they cannot drift apart across the tabs that render a
// history panel: who is allowed to see the panel, and which Forecast_Tab values
// in PC.Forecast_Audit_Log actually belong to a given tab.

// Labor and Equipment are each written under two different Forecast_Tab values
// depending on which editor produced the change — the burn tool writes the plain
// value, the bid/phased forecast writes the "Phased" one. A history filtered on
// only the plain value silently drops every edit made through the phased path,
// so both are queried and merged.
export const AUDIT_TABS_BY_KEY = {
    labor: ['Burn Tool Labor', 'Burn Tool Labor Phased'],
    equipment: ['Burn Tool Equipment', 'Burn Tool Equipment Phased'],
    materials: ['Materials'],
    rentals: ['Rentals'],
    subcontractors: ['Subcontractors'],
    other: ['Other'],
};

// Started as a copy of the guardAdmin expression in sideMenu.js and is kept in
// step with it by hand — if you add someone there, add them here too. The two
// have since diverged by one entry (see below).
//
// Emails are compared against userEmailCheck, which loadData.js lowercases at
// login, so every entry here must be lowercase or it will never match.
export const isAuditAdmin = (userId, userEmail) => (
    process.env.NODE_ENV !== 'production'
    || userId === '154045'
    || userId === '147219'
    || userEmail === 'steve.horman@strikeusa.com'
    || userEmail === 'cameron.pitre@strikeusa.com'
    || userEmail === 'aeron.griggs@strikeusa.com'
    || userEmail === 'bernardo.costa@strikeusa.com'
    || userEmail === 'bcosta@strikeusa.com'
    || userEmail === 'christopher.ellis@strikeusa.com'
    // Added for audit history specifically — not in sideMenu.js guardAdmin,
    // so the two lists now differ deliberately.
    || userEmail === 'elliot.madsen@strikeusa.com'
);
